import GameParameterInterface from '@/models/game/parameters/interface'
import { Property } from '@/models/game/property'
import GameExecutorInterface from '@/services/game/executor/executor-interface'
import GameProcessor from '@/services/game/processor'
import { ScriptLoader } from '@/util/scriptLoader'

interface GameResult {
  isWinning: boolean,
  score: number,
}

interface CompletedCallbackParam {
  gameResult: GameResult,
}

export default class CraneGameExecutor implements GameExecutorInterface {

  constructor(
    private processor: GameProcessor,
    private property: Property,
    private parameter: GameParameterInterface,
    private timeOutUrl: string
  ) { }

  async execute(): Promise<void> {

    const scriptLoader = new ScriptLoader({
      src : this.property.scriptUrl,
      global: 'GAME',
    })

    const game: any = await scriptLoader.load()

    const option = this.parameter.createSetOption()
    const margeOption = {
      result: {
        score: Number(option.generalValue),
        prizeImage: option.prize.prizeImage,
        nextPageUrl: this.processor.makeGameResultUrl(),
      },
    }

    const timeLimit: number = 30

    game.setOption({
      ...margeOption,
      resource: this.property.resourcePath,
      game: 'crane',
      theme: this.property.theme,
      challengeLimit: this.property.challengeLimit,
      timelimit: timeLimit,
      timeOutUrl: this.timeOutUrl,
    })
    .setStarted(() => {

      return this.processor.notifyGameStart({})
    })
    .setCompleted((data: CompletedCallbackParam) => {

      return this.processor.notifyGameComplete({
        result: JSON.stringify({
          isWinning: data.gameResult.isWinning,
          score: data.gameResult.score,
        }),
      })
    })
    .start()
  }
}
